import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f72a9c7")

_pushScopeId("data-v-2f72a9c7")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "title" }, "这是网站使用说明的内容", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_divider = _resolveComponent("el-divider")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_el_divider, { id: "bottom-divider" })
  ]))
})